import { ResponsiveStateExitedEventArgs as ResponsiveStateExitedEventArgs_internal } from "./ResponsiveStateExitedEventArgs";
/**
 * Information about the exited state.
*/
var IgrResponsiveStateExitedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrResponsiveStateExitedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrResponsiveStateExitedEventArgs.prototype.createImplementation = function () {
        return new ResponsiveStateExitedEventArgs_internal();
    };
    Object.defineProperty(IgrResponsiveStateExitedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrResponsiveStateExitedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrResponsiveStateExitedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrResponsiveStateExitedEventArgs;
}());
export { IgrResponsiveStateExitedEventArgs };
//# sourceMappingURL=igr-responsive-state-exited-event-args.js.map
